import { useEffect, useState } from "react";
import './ReportViews.css';
import ComponentView from "../../../components/ComponentView/ComponentView";
import { getReportViews } from "../../../redux/ReportsReducer/action";
import { useDispatch, useSelector } from "react-redux";
import Sidebar from "../../../components/Sidebar/Sidebar";
import UserProfileDropdown from "../../../components/UserProfile/UserProfile";
import SeedsLogo from "../../../assets/images/SeedsLogo.png";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";

const clientID = process.env.REACT_APP_APPSMITH_CLIENT_ID;

const ReportsPage = ({ reportName }) => {
  const { reportViews } = useSelector((store) => {
    return {
        reportViews: store.ReportsReducer.reportViews
    }
  }, []);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    let reportFilters = {
        display_name: reportName
    }
    dispatch(getReportViews(clientID, "REPORTS", reportFilters));
  }, [dispatch]);

  return (
    <div className="reportsDashboardContainer">
        <div className="reportsDashboard">
            <Sidebar />

            <div className="dashboardMainContent">
                <div className="contentHeader">
                    <div className="userLogo">
                        <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
                    </div>
                    <div className="headerRightPanel">
                        <UserProfileDropdown />
                    </div>
                </div>

                <div className="pageHeaderSection">
                    <Breadcrumb items={[
                        { label: 'Admin' },
                        { label: 'Reports', onClick: () => navigate('/reports') },
                        { label: reportName }
                    ]} />
                </div>

                <main className="reports-content">
                    <div className="reports-container">
                        {reportViews?.map(view => (
                            <ComponentView key={view.view_id} view={view} />
                        ))}
                    </div>
                </main>
            </div>
        </div>
    </div>
  );
};

export default ReportsPage;